import { ReactElement } from 'react'

import { Organization, UserPermission } from 'types'

import Branding from './Branding'
import SideMenuFooter from './SideMenuFooter'
import SideMenuMainNavigation from './SideMenuMainNavigation'
import * as styles from './styles.module.scss'

interface Props {
    currentOrganization?: Organization
    isSidebarCollapsed: boolean
    featurePermissions: UserPermission[]
    hasNoIntegrations: boolean
    toggleSidebarCollapsed: () => void
}

const SideMenu = ({
    currentOrganization,
    isSidebarCollapsed,
    featurePermissions,
    hasNoIntegrations,
    toggleSidebarCollapsed,
}: Props): ReactElement => {
    return (
        <div className={styles.siderWrapper}>
            <div className={styles.mainNavWrapper}>
                <Branding
                    currentOrganization={currentOrganization}
                    isSidebarCollapsed={isSidebarCollapsed}
                    toggleSidebarCollapsed={toggleSidebarCollapsed}
                />
                <SideMenuMainNavigation
                    currentOrganization={currentOrganization}
                    featurePermissions={featurePermissions}
                    hasNoIntegrations={hasNoIntegrations}
                />
            </div>
            <div className={styles.bottomMenuContainer}>
                <div className={styles.dividerFullWidth} />
                <SideMenuFooter />
            </div>
        </div>
    )
}

export default SideMenu
